export const OpportunityOverviewIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9997 5.2735C11.9597 5.26683 11.9131 5.26683 11.8731 5.2735C10.9531 5.24017 10.2197 4.48683 10.2197 3.5535C10.2197 2.60016 10.9864 1.8335 11.9397 1.8335C12.8931 1.8335 13.6597 2.60683 13.6597 3.5535C13.6531 4.48683 12.9197 5.24017 11.9997 5.2735Z"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.313 10.1269C12.2263 10.2803 13.233 10.1203 13.9396 9.64694C14.8796 9.02027 14.8796 7.9936 13.9396 7.36694C13.2263 6.8936 12.2063 6.7336 11.293 6.8936"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.97934 5.2735C4.01934 5.26683 4.066 5.26683 4.106 5.2735C5.026 5.24017 5.75934 4.48683 5.75934 3.5535C5.75934 2.60016 4.99267 1.8335 4.03934 1.8335C3.086 1.8335 2.31934 2.60683 2.31934 3.5535C2.326 4.48683 3.05934 5.24017 3.97934 5.2735Z"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66663 10.1269C3.75329 10.2803 2.74663 10.1203 2.03996 9.64694C1.09996 9.02027 1.09996 7.9936 2.03996 7.36694C2.75329 6.8936 3.77329 6.7336 4.68663 6.8936"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99973 10.253C7.95973 10.2463 7.91306 10.2463 7.87306 10.253C6.95306 10.2197 6.21973 9.46632 6.21973 8.53299C6.21973 7.57966 6.98639 6.81299 7.93973 6.81299C8.89306 6.81299 9.65973 7.58632 9.65973 8.53299C9.65306 9.46632 8.91973 10.2263 7.99973 10.253Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.06047 12.3528C5.12047 12.9794 5.12047 14.0061 6.06047 14.6328C7.12714 15.3461 8.8738 15.3461 9.94047 14.6328C10.8805 14.0061 10.8805 12.9794 9.94047 12.3528C8.88047 11.6461 7.12714 11.6461 6.06047 12.3528Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
